// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#user-details[data-v-2535419e]{background-color:#f8fafb;width:266px;-webkit-transition:all .1s;transition:all .1s;overflow:hidden;-webkit-box-shadow:-1px 0 #e6ebed;box-shadow:-1px 0 #e6ebed;z-index:900}#user-details h3[data-v-2535419e]{margin:18px 15px 15px;font-size:16px;font-weight:500;line-height:1.05;color:#141c20}#user-details.hide[data-v-2535419e]{width:0}", ""]);
// Exports
module.exports = exports;
